import { Link, Section, Stack, Typography } from '@cmg/design-system';
import { useMemo } from 'react';

import { OfferingDetails_PublishedOffering_DisclaimersFragment } from '../../offering-side-panel/offering-details/graphql/__generated__';
import { KeyValuePair } from './KeyValuePair';

type GeographicInvestorRestrictionSectionProps = {
  registrationLinks: OfferingDetails_PublishedOffering_DisclaimersFragment['registrationLinks'];
  restrictions: OfferingDetails_PublishedOffering_DisclaimersFragment['restrictions'];
};

export function GeographicInvestorRestrictionSection({
  registrationLinks,
  restrictions,
}: Readonly<GeographicInvestorRestrictionSectionProps>) {
  const publishedRegistrationLinks = useMemo(() => {
    return registrationLinks?.filter(link => !!link && link.trim()) ?? [];
  }, [registrationLinks]);

  const hasRegistrationLinks = publishedRegistrationLinks.length > 0;

  return (
    <Section title="Geographic/Investor Restrictions">
      <Stack gap={2}>
        {restrictions && <Typography>{restrictions}</Typography>}
        <KeyValuePair
          label="Registration Statement(s)"
          value={
            <Typography variant="body1">
              {hasRegistrationLinks
                ? publishedRegistrationLinks.map((link, index) => [
                    index > 0 && ', ',
                    <Link
                      key={index}
                      href={link}
                      data-testid="registration-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {`Registration Link ${index + 1}`}
                    </Link>,
                  ])
                : '-'}
            </Typography>
          }
        />
      </Stack>
    </Section>
  );
}
